import { useQuery } from '@tanstack/react-query';
import { getOpsUserDetails } from '../services/loginService';
export const useGetOpsUserDetails = (email?: string) => {
  const { data, isLoading, isError, error, refetch, isPending } = useQuery({
    queryKey: ['operationUserDetails', email],
    queryFn: async () => {
      if (!email) throw new Error('Email is required'); // safety guard
      return await getOpsUserDetails(email);
    },
    enabled: !!email,
    staleTime: 0,
    gcTime: 0,
  });

  return {
    operationUserDetails: data,
    isLoading,
    isError,
    isPending,
    error,
    refetch,
  };
};
